import { ReactComponent as Logo } from "../assets/Smart_Pocket_V2_Logo_Web_200x40px.svg";

const SmartLogo = () => {
	return (
		<div className="w-40 md:w-72 lg:w-40">
			<Logo />
		</div>
	);
};

export { SmartLogo };
